import { OrbitalTrackRentalPopupType } from '@apeiron/orbital'
import { ApeironBlueButton } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { useOrbitalTrackRenewDetachContext } from '@src/contexts/orbitalTrack/OrbtialTrackRenewDetachContext'
import useOrbitalTrackAttach from '@src/hooks/contract/useOrbitalTrackAttach'
import { OrbitalTrackLite } from '@src/types/orbitalTrack'
import * as R from 'ramda'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  justify-content: center;
  display: flex;
  padding: 20px;
`

const EndButton = styled(ApeironBlueButton)`
  width: 200px;
`

const DoneButton = EndButton

const RenewButton = styled(EndButton)`
  --background-color: #ffbf36;
  color: black;
`

const RentalConfirmSection: FC<Props> = props => {
  const {
    className,
    popupType,
    tracks = [],
    isMultipleView = false,
    onConfirm,
    onSuccess
  } = props

  const { t } = useTranslation()

  const multipleViewClassName = isMultipleView ? 'multipleView' : ''

  const { checked, done, successIds } = useOrbitalTrackRenewDetachContext()

  const { detachPlanets, renewPlanets } = useOrbitalTrackAttach()

  const handleOnEndAll = useCallback(async () => {
    if (!R.isEmpty(tracks)) {
      const detachedIds = await detachPlanets(tracks)

      if (!R.isEmpty(detachedIds)) {
        if (onSuccess) {
          onSuccess(detachedIds)
        }
      }
    }
  }, [detachPlanets, onSuccess, tracks])

  const handleOnRenewAll = useCallback(async () => {
    if (!R.isNil(tracks)) {
      const renewedIds = await renewPlanets(tracks)

      if (!R.isEmpty(renewedIds)) {
        if (onSuccess) {
          onSuccess(renewedIds)
        }
      }
    }
  }, [onSuccess, renewPlanets, tracks])

  const handleOnConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm(successIds)
    }
  }, [onConfirm, successIds])

  return (
    <Container className={className}>
      {done ? (
        <DoneButton onClick={handleOnConfirm}>
          {t('common.button.done')}
        </DoneButton>
      ) : popupType === OrbitalTrackRentalPopupType.Renew ? (
        <RenewButton
          disabled={!checked}
          onClick={handleOnRenewAll}
          className={multipleViewClassName}
        >
          {isMultipleView
            ? t('godiverse.orbital_track.rental_popup.renew_all')
            : t('common.button.renew')}
        </RenewButton>
      ) : (
        <EndButton
          disabled={!checked}
          className={multipleViewClassName}
          onClick={handleOnEndAll}
        >
          {isMultipleView
            ? t('godiverse.orbital_track.rental_popup.end_all')
            : t('common.button.end')}
        </EndButton>
      )}
    </Container>
  )
}

type Props = {
  className?: string
  isMultipleView?: boolean
  popupType?: OrbitalTrackRentalPopupType
  tracks?: OrbitalTrackLite[]
  onConfirm?: (successIds: string[]) => void
  onSuccess?: (successIds: string[]) => void
}

export default RentalConfirmSection
